import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRouteHook, useTabs } from '@shared/hooks';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { Header } from './header';
import { Nav } from './nav';

interface SidebarProps {
  className?: string;
  open?: boolean;
  onClose?: () => void;
}

export const Sidebar = (props: SidebarProps) => {
  const location = useLocation();
  const { navigate } = useRouteHook();

  const tabsState = useTabs();
  useEffect(() => {
    if (tabsState.loading) return;
    const isOnPaymentsRoute = location.pathname.startsWith(RoutePaths.payments.onNavigate());
    if (isOnPaymentsRoute && !tabsState.hasPayment) navigate(RoutePaths.dashboard.onNavigate());
  }, [location.pathname, tabsState.loading, tabsState.hasPayment]);

  return (
    <>
      {props.open && <div className={cn('fixed inset-0 z-40 bg-black/50', 'md:hidden')} onClick={props.onClose} />}
      <aside
        className={cn(
          'flex h-screen flex-col border-r border-r-gray-black bg-white dark:border-r-gray-wet-asphalt dark:bg-soft-black',
          'max-md:fixed max-md:z-50 max-md:transition-transform max-md:duration-300',
          props.open ? 'max-md:translate-x-0' : 'max-md:-translate-x-full',
          PaletteUtils.isVcfcPalette && 'bg-primary',
          props.className,
        )}
      >
        <Header />
        <Nav />
      </aside>
    </>
  );
};
